define('ctrl/member/member-reset-password-result',['require','ns','ctrl/base'],function (require) {
    'use strict';

    var ns = require('ns');

    var BaseController = require('ctrl/base');

    var _selector = {
        redirectBtn: '#redirect-btn'
    };

    var $selector = {};

    var MemberResetPasswordResultController = BaseController.extend({
        init: function () {

            BaseController.prototype.init.call(this);

            $selector = ns.utils.generateSelector(_selector);

            this._registerEvent();
        },
        _registerEvent: function () {
            $selector.redirectBtn.click(function () {
                var $self = $(this);
                var url = $self.attr("data-url");
                var fallback = $self.attr("data-fallback");
                if (!_.isNull(fallback) && !_.isEmpty(fallback) && !_.isUndefined(fallback)) {
                    setTimeout(function () {
                        window.location = fallback;
                    }, 250);
                }
                window.location = url;
            });
        }
    });

    return MemberResetPasswordResultController;
});
